var map = {
	"./Facebook.svg": 289,
	"./Insta.svg": 288,
	"./Linkedin.svg": 292,
	"./Twitter.svg": 290,
	"./Youtube.svg": 291,
	"./bncimagenes.png": 494,
	"./bonificaciones.png": 495,
	"./calendar.svg": 296,
	"./clientes.svg": 496,
	"./download.svg": 497,
	"./editar.svg": 297,
	"./editar_black.svg": 298,
	"./excel-logo.png": 299,
	"./manualmarca.png": 498,
	"./menu.svg": 295,
	"./precios.png": 499,
	"./presupuesto.svg": 500,
	"./vendedores.svg": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;